export default __webpack_public_path__ + "static/media/transaction.726deb16.svg";